module.exports = __webpack_public_path__ + "static/media/4-cut.1085374d.png";